var map = {
	"./Corteva_Do_More_with_Less-desktop.jpg": 273,
	"./Corteva_Do_More_with_Less-mobile.jpg": 274,
	"./Corteva_Do_More_with_Less-tablet.jpg": 275,
	"./Corteva_From_Data_to_Decision-desktop.jpg": 276,
	"./Corteva_From_Data_to_Decision-mobile.jpg": 277,
	"./Corteva_From_Data_to_Decision-tablet.jpg": 278,
	"./Corteva_How_the_world_grows_TMT-CORT003-120-desktop.jpg": 279,
	"./Corteva_How_the_world_grows_TMT-CORT003-120-mobile.jpg": 280,
	"./Corteva_How_the_world_grows_TMT-CORT003-120-tablet.jpg": 281,
	"./Farming_where_it_doesnt_rain_tablet.png": 282,
	"./TMT-CORT010-120-desktop.jpg": 283,
	"./TMT-CORT010-120-mobile.jpg": 284,
	"./TMT-CORT010-120-tablet.jpg": 285,
	"./Tanzania-Queen-and-Son-small-desktop.jpg": 286,
	"./Tanzania-Queen-and-Son-small-mobile.jpg": 287,
	"./Tanzania-Queen-and-Son-small-tablet.jpg": 288,
	"./Thailand-desktop.jpg": 289,
	"./Thailand-mobile.jpg": 290,
	"./Thailand-tablet.jpg": 291,
	"./art-of-precision.jpg": 292,
	"./brasil_new_pastures-desktop.jpg": 293,
	"./brasil_new_pastures-mobile.jpg": 294,
	"./brasil_new_pastures-tablet.jpg": 295,
	"./cracking-the-code-desktop.jpg": 296,
	"./cracking-the-code-mobile.jpg": 297,
	"./cracking-the-code-tablet.jpg": 298,
	"./seeds-of-change-desktop.jpg": 299,
	"./seeds-of-change-mobile.jpg": 300,
	"./seeds-of-change-tablet.jpg": 301,
	"./silicon-farm-poster-desktop.jpg": 302,
	"./silicon-farm-poster-mobile.jpg": 303,
	"./silicon-farm-poster-tablet.jpg": 304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 515;